export const isEmpty = (text) => text === undefined || text === null || text.trim() === '';
export const isNotEmpty = (text) => !isEmpty(text);
